import { combineReducers } from 'redux';
import coreReducer from './core';
import appSettingsReducer from './app-settings';
import cmmeReducer from './cmme';
export default combineReducers({
    core: coreReducer,
    appSettingsReducer: appSettingsReducer,
    cmmeReducer: cmmeReducer,
});
